<template>
  <div class="defaultLayout">
    <Navigation />
    <div class="main-container align-items-stretch">
      <Header />

      <router-view></router-view>

      <Footer />
    </div>
  </div>
</template>
<style>
body {
  font-family: "Rubik", sans-serif;
}
.dropdown-icon .dropdown-menu a span.text{
  float:left;
  padding-right:0px;
  display:none;
  color:#fd3e75;
}
.dropdown-icon .dropdown-menu a img{
    width:16px;
    float:right;
}
.dropdown-icon .dropdown-menu a span.icon-hover{
    display:none;
}
.dropdown-icon .dropdown-menu{
  background:none !important;
  box-shadow:none !important;
  top:0px;
}
.dropdown-icon .dropdown-menu a{
  padding: 0.4rem 2rem !important;
}
</style>
<script>
import Navigation from "./partials/Navigation";
import Header from "./partials/Header";
import Footer from "./partials/Footer";

export default {
  name: "DefaultLayout",
  components: {
    Header,
    Navigation,
    Footer
  },
  mounted() {
    $("html").css("overflow-y", "auto");
    $(".modal-backdrop").remove();
    if ($(".overlay").length > 0) {
      $(".overlay").remove();

    }
    $("#sidebarCollapse").on("click", function() {
      $("#sidebar").toggleClass("active");
      $("body").toggleClass("active");
      $(this).toggleClass("active");
      $("body").trigger("sidebarcollapse");
    });

    $("body").on("sidebarcollapse", function() {
      if ($("#sidebar").hasClass("active")) {
        $("body").prepend('<div id="overlay" class="overlay"></div>');
        $("html").css("overflow-y", "hidden");
        $("#sidebarHome").hide();
      } else {
        $(".overlay").remove();
        $("html").css("overflow-y", "auto");
        $("#sidebarHome").show();
      }
    });

    // ACCORDION TITLE ACTIVE CLASS ADDED AND REMOVED
    $(".card-header h5").on("click", function() {
      // $(this).toggleClass("active");
      // $(this)
      //   .closest(".card")
      //   .find(".collapse")
      //   .toggleClass("show");
    });

    //for icon hover in dropdown
    $("body").on('mouseover',".dropdown-item",function(){+   
      $(this).find('span.text').show();
      $(this).find('span.icon-hover').show();
      $(this).find('span.icon-default').hide();
    });
      $("body").on('mouseout',".dropdown-item",function(){+   
      $(this).find('span.text').hide();
      $(this).find('span.icon-hover').hide();
      $(this).find('span.icon-default').show();
    });
  }
};
</script>